import { render, staticRenderFns } from "./PhoneVerificationCheckPage.vue?vue&type=template&id=7f5412ce&scoped=true&"
import script from "./PhoneVerificationCheckPage.vue?vue&type=script&lang=js&"
export * from "./PhoneVerificationCheckPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5412ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VApp,VContainer,VContent,VFlex,VLayout})
